import { createSlice } from '@reduxjs/toolkit';

export const connectedSlice = createSlice({
  name: 'connected',
  initialState: false,
  reducers: {
    connectedSet: (_, { payload: connected }: { payload: boolean }) =>
      connected,
  },
});

export const { connectedSet } = connectedSlice.actions;
